import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  ScrollView,
} from "react-native";
import React, { useState } from "react";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";

import VehicleActive from "./VehicleActive";
import VehicleHistory from "./VehicleHistory";

const VehicleAssistant = ({ navigation }) => {
  const [activeTab, setActiveTab] = useState("Active");

  // Render content based on active tab
  const renderContent = () => {
    switch (activeTab) {
      case "Active":
        return <VehicleActive />;
      case "History":
        return <VehicleHistory />;
      default:
        return <VehicleActive />;
    }
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: AppColors.white,
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 10 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{ height: 30, width: 30, justifyContent: "center" }}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15 }}
            />
          </TouchableOpacity>
          <Text
            style={{
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,
              color: AppColors.brown1,
              marginLeft: 15,
            }}
          >
            Vehicle Assistants
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("AddVehicleAssistant")}
          >
            <Image
              source={AppImages.Plus}
              style={{ width: 18, height: 18, marginLeft: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      {/* Custom Tab Bar */}
      <View style={{ marginTop: 20, backgroundColor: AppColors.white }}>
        <View style={styles.tabContainer}>
          <TouchableOpacity
            style={[
              styles.tabButton,
              activeTab === "Active" && styles.activeTabButton,
            ]}
            onPress={() => setActiveTab("Active")}
          >
            <Text
              style={[
                styles.tabText,
                activeTab === "Active" && styles.activeTabText,
              ]}
            >
              Active
            </Text>
            {activeTab === "Active" && <View style={styles.indicator} />}
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.tabButton,
              activeTab === "History" && styles.activeTabButton,
            ]}
            onPress={() => setActiveTab("History")}
          >
            <Text
              style={[
                styles.tabText,
                activeTab === "History" && styles.activeTabText,
              ]}
            >
              History
            </Text>
            {activeTab === "History" && <View style={styles.indicator} />}
          </TouchableOpacity>
        </View>
      </View>

      {/* Tab Content */}
      <View style={{ flex: 1, backgroundColor: AppColors.sandal }}>
        <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false}>
          {renderContent()}
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default VehicleAssistant;

const styles = StyleSheet.create({
  tabContainer: {
    flexDirection: "row",
    backgroundColor: AppColors.white,
    paddingHorizontal: 20,
  },
  tabButton: {
    flex: 1,
    alignItems: "center",
    paddingVertical: 16,
    position: "relative",
  },
  activeTabButton: {
    // You can add active background styles here if needed
  },
  tabText: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    color: "#9C4900CC",
    textTransform: "none",
  },
  activeTabText: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  indicator: {
    position: "absolute",
    bottom: 0,
    height: 3,
    width: "100%",
    backgroundColor: "#8F4300",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
});
